import {
  APP_PAGE_MOUNT,
  APP_PAGE_UNMOUNT,
  TOGGLE_NAVIGATION_DRAWER,
  FETCH_USER_PROFILE,
  FETCH_USER_PROFILE_START,
  FETCH_USER_PROFILE_SUCCESS,
  FETCH_USER_PROFILE_ERROR,
} from './constants'

const toggleNavigationDrawer = () => ({ type: TOGGLE_NAVIGATION_DRAWER })
const appPageMount = () => ({ type: APP_PAGE_MOUNT})
const appPageUnmount = () => ({ type: APP_PAGE_UNMOUNT})

const fetchUserProfile = () => ({ type: FETCH_USER_PROFILE })
const fetchUserProfileStart = () => ({ type: FETCH_USER_PROFILE_START })
const fetchUserProfileSuccess = (attributes) => ({ type: FETCH_USER_PROFILE_SUCCESS, attributes })
const fetchUserProfileError = (error) => ({ type: FETCH_USER_PROFILE_ERROR, error })

export {
  appPageMount,
  appPageUnmount,
  toggleNavigationDrawer,
  fetchUserProfile,
  fetchUserProfileStart,
  fetchUserProfileSuccess,
  fetchUserProfileError,
}
